import { memo, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import newImg from '../../../assets/images/newPres.png';
import LoadingSaveBtn from '../../forms/LoadingSaveBtn';
import PopupModal from '../modals/PopupModal';
import SettingsModal from '../modals/SettingsModal';

const PrescriptionSaveBtns = ({
  templateId,
  loadingStatus,
  handleSubmit,
  prescriptionId,
  resetPrescription,
  setIsTemplateModal,
  hideItems,
  setHideItems,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isShow, setIsShow] = useState(false);

  return (
    <Row className="prescription-save-btn mb-2 mt-5 footer-area">
      <Col className="button-area text-center">
        {loadingStatus ? (
          <LoadingSaveBtn />
        ) : (
          <Button
            variant="primary"
            className="mr-3 save-button"
            size="md"
            onClick={() => handleSubmit('save')}
          >
            Save
          </Button>
        )}
      </Col>
      <Col className="button-area text-center">
        {loadingStatus ? (
          <LoadingSaveBtn />
        ) : (
          <Button
            variant="primary"
            className="mr-3 save-button"
            size="md"
            onClick={() => handleSubmit('saveAndPrint')}
          >
            Save & Print
          </Button>
        )}
      </Col>
      <Col className="button-area text-right">
        <PopupModal
          resetPrescription={resetPrescription}
          showConfirmModal={showConfirmModal}
          setShowConfirmModal={setShowConfirmModal}
        />
        <SettingsModal
          isShow={isShow}
          setIsShow={setIsShow}
          hideItems={hideItems}
          setHideItems={setHideItems}
        />
        <div className="new-pres-btn" style={{ right: '85px' }}>
          <img
            src={newImg}
            title="Create New Prescription"
            height={55}
            width={55}
            alt=""
            onClick={() =>
              prescriptionId ? resetPrescription() : setShowConfirmModal(true)
            }
          />
        </div>
        <div
          className="new-pres-btn"
          style={{ fontSize: '25px', paddingTop: '8px' }}
          onClick={() => setIsShow(true)}
        >
          <i className="fa fa-cog"></i>
        </div>
        <Button
          variant="primary"
          className="mr-3 save-button"
          size="md"
          onClick={() => setIsTemplateModal(true)}
        >
          {templateId ? 'Update' : 'Save'} Template
        </Button>
      </Col>
    </Row>
  );
};

export default memo(PrescriptionSaveBtns);
